import {
  LOAD_NEW_CONTENT,
  LOAD_NEW_CONTENT_SUCCESS,
  LOAD_POPULAR_CONTENT,
  LOAD_POPULAR_CONTENT_SUCCESS,
  LOAD_SEARCH_CONTENT,
  LOAD_SEARCH_CONTENT_SUCCESS,
} from './constants';

export const initialState = {
  templates: [],
  currentPageOfCategoryPageTemplate: 0,
  totalCategoryPageTemplates: 0,
  numberPagesOfCategoryPage: 0,
  isLoadingCategoryPageTemplates: false,
  hasMoreCategoryPageTemplates: true,
};

function templatePageReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_NEW_CONTENT:
      return {
        ...state,
        isLoadingCategoryPageTemplates: true,
      };
    case LOAD_NEW_CONTENT_SUCCESS:
      return {
        ...state,
        templates: action.payload.templates,
        currentPageOfCategoryPageTemplate: action.payload.currentPage,
        totalCategoryPageTemplates: action.payload.total,
        numberPagesOfCategoryPage:
          action.payload.numberPages > 0 ? action.payload.numberPages : 1,
        isLoadingCategoryPageTemplates: false,
      };
    case LOAD_POPULAR_CONTENT:
      return {
        ...state,
        isLoadingCategoryPageTemplates: true,
      };
    case LOAD_POPULAR_CONTENT_SUCCESS:
      return {
        ...state,
        templates: action.payload.templates,
        currentPageOfCategoryPageTemplate: action.payload.currentPage,
        totalCategoryPageTemplates: action.payload.total,
        numberPagesOfCategoryPage:
          action.payload.numberPages > 0 ? action.payload.numberPages : 1,
        isLoadingCategoryPageTemplates: false,
      };
    case LOAD_SEARCH_CONTENT:
      return {
        ...state,
        isLoadingCategoryPageTemplates: true,
      };
    case LOAD_SEARCH_CONTENT_SUCCESS:
      return {
        ...state,
        templates: action.payload.templates,
        currentPageOfCategoryPageTemplate: action.payload.currentPage,
        totalCategoryPageTemplates: action.payload.total,
        numberPagesOfCategoryPage:
          action.payload.numberPages > 0 ? action.payload.numberPages : 1,
        isLoadingCategoryPageTemplates: false,
      };
    default:
      return state;
  }
}

export default templatePageReducer;
